export const UPDATING_USER_DATA = 'auth/updating_user_data';
export const UPDATE_USER_DATA_SUCCESS = 'auth/update_user_data_success';
export const UPDATE_USER_DATA_ERROR = 'auth/update_user_data_error';
